import { apiServer } from "../../api";
import { IPlanoContratado } from "./types";

export const buscarPlanoAtual = (clienteID: string, token: string) => {
  return apiServer<IPlanoContratado>().get(`v2/clientes/${clienteID}/plano-atual`, token);
};
